import React from 'react';
import './LineText.css';

export const LineText = ({ text, overTextLine }) => (
  <div className="boxText">
    <p className="text">{text}</p>
    {overTextLine && <hr className="overTextLine" />}
  </div>
);
